import { get, post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';
import { getErrorMessage } from '../../errorBuilder';

export const getAdminClients = async (params) => {
  const builder = new UrlBuilder(`/manage/clients/list`);
  builder.add('page', params?.page || 1);
  builder.add('pageSize', params?.limit || 10);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createClient = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/create`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const updateClient = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/update`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const deleteClient = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/delete`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const regenerateClientCode = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/regenerate-client-code`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const inviteClient = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/invite`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const viewDocument = async (payload) => {
  const builder = new UrlBuilder(`/manage/clients/view-document`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
